import { render } from "./DateSelectComponent.vue?vue&type=template&id=18d0fb90&scoped=true"
import script from "./DateSelectComponent.vue?vue&type=script&lang=js"
export * from "./DateSelectComponent.vue?vue&type=script&lang=js"

import "./DateSelectComponent.vue?vue&type=style&index=0&id=18d0fb90&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d0fb90"]])

export default __exports__